import { graphql } from '@graphql/__generated'

export const DUPLICATE_EVENT_BY_ID = graphql(`
  mutation duplicateEventById($eventId: String!) {
    duplicateEventById(eventId: $eventId) {
      success
      event {
        eventId
      }
    }
  }
`)
